import { setupIonicReact } from '@ionic/react';
import React from 'react';
import { createRoot } from 'react-dom/client';

import '@/styles/reset.css';
import '@/styles/global.css';
import '@/styles/ionic/variables.css';
import '@/styles/ionic/styles.css';
import '@/styles/vanilla/variables.css';

import 'react-loading-skeleton/dist/skeleton.css';

import { ErrorBoundary } from '@/components/Common';
import { bridge, ClientType } from '@/lib/bridge';
import { initLogs, initRum } from '@/lib/datadog';
import { AppProvider } from '@/providers/App';
import { syncNativeAppContext, invalidate } from '@/redux/slices/appSlice';
import { store } from '@/redux/store';

import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root') as HTMLDivElement;
const root = createRoot(container);

// Redux bootstrapping
window.invalidate = () => store.dispatch(invalidate());
store.dispatch(syncNativeAppContext());

// Ionic setup
setupIonicReact({
  // Adjusts ionic styles and animations based
  // on user agent (ios & android).
  platform: {
    ios: () => bridge.clientType === ClientType.iOS,
    android: () => bridge.clientType === ClientType.Android,
  },
});

// Initialize Datadog reporting
initRum();
initLogs();

console.info(`%cENV: ${import.meta.env.MODE}`, 'color: purple; font-size: 16px');

root.render(
  <ErrorBoundary scope="global-error-boundary" fallback="There was an error.">
    <AppProvider>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </AppProvider>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
